import React from "react";

interface EditableTextProps {
  value: string;
  onChange: (value: string) => void;
  textAlign?: "left" | "center" | "right";
  size?: number;
  color?: string;
}

export const EditableText: React.FC<EditableTextProps> = ({
  value,
  onChange,
  textAlign = "left",
  size = 30,
  color = "white",
}) => (
  <input
    type="text"
    value={value}
    onChange={(event) => onChange(event.target.value)}
    style={{ textAlign, fontSize: `${size}px`, color }}
    className="w-full bg-transparent outline-none font-semibold"
  />
);
